import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import BarChart from "../components/BarChart";
import useMonthlySales from "../hooks/useMonthlySales";
import formatearCantidad from "../funciones/convertirAMoneda";
import PieChart from "../components/PieChart";
import { Link, useNavigate } from 'react-router-dom';
import { React, useEffect, useState } from "react";
import useWeeklySales from "../hooks/useWeeklySales";
import { getExpenses } from "../firebase/firebaseOps";
import { useAuth } from "../context/AuthContext";
import BarChartVE from "../components/BarChartVE";
import { endOfMonth, getUnixTime, startOfMonth } from "date-fns";
import './SummaryContainer.css';
import useOrders from "../hooks/useOrders";

const SummaryContainer = () => {
    const navigate = useNavigate();
    const { usuario } = useAuth();
    const orders = useOrders();

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [monthLetters, setMonthLetters] = useState(new Date(0, selectedMonth).toLocaleString('default', { month: 'long' }));
    const monthlySales = useMonthlySales(selectedMonth, selectedYear);
    const [expenses, setExpenses] = useState([]);

    const weeklySales = useWeeklySales();
    const [graph, setGraph] = useState({ field: 'type', desc: 'Por Categoría' });
    let total = 0;

    useEffect(() => {
        const fetchExpenses = async () => {
            const startDate = getUnixTime(startOfMonth(new Date(selectedYear, selectedMonth))) * 1000;
            const endDate = getUnixTime(endOfMonth(new Date(selectedYear, selectedMonth))) * 1000;
            const expensesData = await getExpenses(startDate, endDate, usuario.uid);

            setExpenses(expensesData);
        };

        fetchExpenses();
    }, [selectedMonth, selectedYear, usuario]);

    const handleMonthChange = (e) => {
        setMonthLetters(new Date(0, e.target.value).toLocaleString('default', { month: 'long' }));
        setSelectedMonth(parseInt(e.target.value));
    }

    const handleYearChange = (e) => {
        setSelectedYear(parseInt(e.target.value));
    }

    const sumExpenses = (expenses) => {
        return expenses.reduce((sum, expense) => sum + parseFloat(expense.amount), 0);
    }
    const totalExpenses = sumExpenses(expenses);

    const lastWeek = (data) => {
        const ahora = Date.now() / 1000;
        const unaSemanaEnSegundos = 7 * 24 * 60 * 60;
        const transaccionesUltimaSemana = data.filter(item => {
            const withinLastWeek = (ahora - item.date) <= unaSemanaEnSegundos;
            return withinLastWeek;
        });
        const suma = transaccionesUltimaSemana.reduce((acc, item) => {
            return acc + parseFloat(item.amount);
        }, 0);
        return suma;
    }


    const todaySales = (data) => {
        const currentDate = new Date();
        const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() / 1000;
        const endOfDay = startOfDay + 86400; // 86400 segundos en un día 
        // Filtrar los registros que corresponden a la fecha de hoy 
        const todayData = data.filter(item => item.date >= startOfDay && item.date < endOfDay);
        // Sumar los amounts de los registros filtrados 
        return todayData.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    }

    const handleChange = (e) => {
        const value = e.target.value

        if (value === 'type') {
            setGraph({ field: 'type', desc: 'Por categoría' });
        } else if (value === 'tipoPago') {
            setGraph({ field: 'payment', desc: 'Por tipo pago' });
        } else if (value === 'place') {
            setGraph({ field: 'place', desc: 'Por lugar' });
        }
    }

    monthlySales?.forEach(element => {
        total = total + parseFloat(element.amount);
    });

    const currentDate = Math.floor(Date.now() / 1000);
    const threeDaysLater = currentDate + (3 * 24 * 60 * 60);
    const upcomingOrders = orders.filter(order => order.dueDate >= currentDate && order.dueDate <= threeDaysLater);

    return (
        <>
            <h1>Resumen de Ventas</h1>
            <Container>
                <Row className="container-margin">
                    <Col>
                        <Form.Select className="form-select" value={selectedMonth} onChange={handleMonthChange}>
                            {Array.from({ length: 12 }, (_, i) => {
                                const month = new Date(0, i).toLocaleString('default', { month: 'long' });
                                return <option key={i} value={i}>{month}</option>
                            })}
                        </Form.Select>
                    </Col>
                    <Col>
                        <Form.Select className="form-select" value={selectedYear} onChange={handleYearChange}>
                            {Array.from({ length: 5 }, (_, i) => {
                                const year = new Date().getFullYear() - i;
                                return <option key={i} value={year}>{year}</option>
                            })}
                        </Form.Select>
                    </Col>
                </Row>
                <hr className="hr-style" />
                <Row>
                    <h4>Ventas hoy: {formatearCantidad(todaySales(weeklySales))}</h4>
                </Row>
                <Row>
                    <h4>Ventas últimos 7 días: {formatearCantidad(lastWeek(weeklySales))}</h4>
                </Row>
                <Row>
                    <h4>Ventas {monthLetters}: {formatearCantidad(total)}</h4>
                </Row>
                <Row>
                    <h4>Gastos {monthLetters}: {formatearCantidad(totalExpenses)}</h4>
                </Row>
            </Container>
            <hr className="hr-style" />
            <div>
                <Button className="button-margin" size="md" onClick={() => navigate('/sales')}>
                    {'Venta'}
                </Button>
                <Button className="button-margin" size="md" onClick={() => navigate('/expenses')}>
                    {'Gasto'}
                </Button>
                <Button className="button-margin" size="md" onClick={() => navigate('/monthlyPayments')}>
                    {'Apartado'}
                </Button>
                <Button className="button-margin" size="md" onClick={() => navigate('/orders')}>
                    {'Pedido'}
                </Button>
            </div>
            <hr className="hr-style" />

            {
                (upcomingOrders && upcomingOrders.length > 0) ?
                    <div>
                        <h2>Próximos Pedidos</h2>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Fecha de Entrega</th>
                                    <th>Teléfono</th>
                                </tr>
                            </thead>
                            <tbody>
                                {upcomingOrders.map(order => (
                                    <tr key={order.id}>
                                        <td><Link to={`/orders?id=${order.id}`}>{order.name}</Link></td>
                                        <td>{order.displayDate}</td>
                                        <td>{order.phone}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div> :
                    null
            }

            <hr className="hr-style" />
            <h2>Gráficos de Ventas</h2>
            <Container fluid="md">
                <Row>
                    <h3>Últimos 7 días</h3>
                </Row>
                <Row>
                    {(weeklySales && weeklySales.length > 0) ? <BarChart sales={weeklySales} /> : <h3 className="row-margin">Sin datos</h3>}
                </Row>
                <Form.Select className="form-select" onChange={handleChange}>
                    <option value="type">Por Categoría</option>
                    <option value="tipoPago">Por Pago</option>
                    <option value="place">Por Lugar</option>
                </Form.Select>
                <Row>
                    {(monthlySales && monthlySales.length > 0) ? <PieChart sales={monthlySales} field={graph.field} /> : <h3 className="row-margin">Sin datos</h3>}
                </Row>
            </Container>
            <Container fluid="md">
                <h3 className="row-margin">Ventas vs Gastos Totales</h3>
                <Row>
                    <BarChartVE sales={total} expenses={totalExpenses} />
                </Row>
            </Container>
        </>
    );
}

export default SummaryContainer;
